import Placeholder from "../components/Placeholder";

export default function Order() {
  return (
    <Placeholder title="Order Page" />
  );
}
